import type { PropsWithChildren, FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { DashButton } from '../../dash-blocks/dash-button/DashButton'
import { type TestableProps } from '../../common/utils/testing/testing.types'
import { type DashMessages } from '../../../intl/intl.types'
import { useDashIntl } from '../../../intl/intl.hooks'
import EmptyView, { type EmptyViewProps } from '../../components/EmptyView'

type Props = Pick<EmptyViewProps, 'style'> &
  TestableProps & {
    titleId: DashMessages
    bodyId: DashMessages
  }

function reloadPage() {
  window.location.reload()
}

export const EmptyViewReload: FunctionComponent<PropsWithChildren<Props>> = ({
  titleId,
  bodyId,
  style = { padding: 30 },
  testId,
}) => {
  const intl = useDashIntl()
  const action = (
    <DashButton onClick={reloadPage} testId="empty-view-reload" size="large">
      <FormattedMessage id="common.reloadPage" />
    </DashButton>
  )

  return (
    <EmptyView
      data-testid={testId}
      iconName="warning"
      size="large"
      title={intl.formatMessage({ id: titleId })}
      body={intl.formatMessage({ id: bodyId })}
      action={action}
      style={style}
    />
  )
}
